angular.module('zc.zenclerkS')
  .component('zcsAgencySidebar', {
    templateUrl: '/templates/zenclerk_s/agencies/sidebar.html',
    controllerAs: 'vm',
    controller: zcsAgencySidebar,
  });

zcsAgencySidebar.$inject = ['$scope', '$state', '$stateParams', 'Agency', 'Devise'];
function zcsAgencySidebar($scope, $state, $stateParams, Agency, Devise) {
  const vm = this;

  vm.agency = {};
  vm.$stateParams = $stateParams;
  vm.isCategory = isCategory;

  function isCategory(category) {
    if(_.get($state, 'current.data.category') === category) {
      return true;
    }
    return false;
  }

  $scope.$watch('vm.$stateParams', function(newval) {
    if(newval) {
      Agency.get(`name:${newval.agencyName}`).then(res => { vm.agency = res });
    }
  });

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/zcs_agency_sidebar.directive.js